import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoginRequest, LoginResponse, ApiService, ValidationResponse, ApiResponse } from "../../services/ApiService";
import AuthValidation from "../../models/validation/AuthValidation";
import { CookieService } from './../../services/CookieService';
import { Router } from '@angular/router';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SignInPageComponent implements OnInit {

  model: LoginRequest;
  show_error: boolean = false;
  error_text: string = "";
  is_loading: boolean = false;

  constructor(private ref: ChangeDetectorRef, private router: Router, private apiService: ApiService, private cookieService: CookieService) { }

  ngOnInit(): void {
    this.cookieService.Redirect(this.router, "sign-in");
    this.model = new LoginRequest("", "");
  }

  /**
   * Called when the 'Sign In' button is pressed.
   */
  signInPressed(): void {
    let modelValid: ValidationResponse = this.model.isValid();
    if (!modelValid.isSuccess) {
      this.show_error = true;
      this.error_text = modelValid.error;
      return;
    }

    // Send the login request
    this.show_error = false;
    this.is_loading = true;
    this.apiService.authToken = "";
    this.apiService.SendRequest<LoginResponse>(this.model,
      (response: ApiResponse<LoginResponse>) => {
        if (response.isSuccess) {
          this.cookieService.SetValue("Email", response.values.email);
          this.cookieService.SetValue("Username", response.values.username);
          this.cookieService.SetValue("AuthToken", response.values.token);
          if (response.values.email_verified) {
            this.cookieService.SetValue("EmailVerified", "true");
            this.router.navigate(["/dashboard"]);
          } else {
            this.cookieService.SetValue("EmailVerified", "false");
            this.router.navigate(["/email-verif"]);
          }
          return true;
        } else {
          this.show_error = true;
          this.error_text = response.getPrimaryErrorMessage();
        }
        this.is_loading = false;
        this.ref.detectChanges();
        return false;
      }
    );
  }
}
